<template>
	<span :hidden="!isAdminStatus">
		<a
			:aria-expanded="troubleCollaps"
			class="sidebar-menu-item nav-link"
			data-toggle="collapse"
			@click="troubleCollaps = !troubleCollaps"
		>
			<template>
				<i class="fa pr-2 fa-tools text-orange"></i>
				<span class="nav-link-text">Troubleshooting<b class="caret"></b></span>
			</template>
		</a>
		<collapse-transition :duration="{enter: 500, leave: 500}">
			<div v-show="troubleCollaps" id="collapse-just" :class="troubleCollaps ? 'show' : ''" class="collapse">
				<ul class="nav nav-sm flex-column">
					<slot name="title">
						<router-link
							:target="link.target"
							class="nav-link"
							href="/overwatch"
							to="/overwatch"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-cogs text-yellow pr-2"></i>
								<span class="nav-link-text">Overwatch (SS7)</span>
							</template>
						</router-link>
					</slot>

					<!-- <slot name="title">
						<router-link
							:target="link.target"
							class="nav-link"
							href="/rfreports"
							to="/rfreports"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-cogs text-red pr-2"></i>
								<span class="nav-link-text">RF Reports</span>
							</template>
						</router-link>
					</slot> -->

					<!--                    <slot name="title">-->
					<!--                        <router-link-->
					<!--                            :target="link.target"-->
					<!--                            class="nav-link"-->
					<!--                            href="/diameter"-->
					<!--                            to="/diameter"-->
					<!--                            @click.native="linkClick"-->
					<!--                        >-->
					<!--                            <template>-->
					<!--                                <i class="fa fa-cogs text-green pr-2"></i>-->
					<!--                                <span class="nav-link-text">Diameter Reports</span>-->
					<!--                            </template>-->
					<!--                        </router-link>-->
					<!--                    </slot>-->
				</ul>
			</div>
		</collapse-transition>
	</span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "../../../common/api-services/init-service";

export default {
	name: "side-trouble-basic-group",
	components: {
		CollapseTransition,
	},
	data() {
		return {
			isAdminStatus: false,
			groups: [],
			navLinks: [],

			troubleCollaps: false,
			link: {
				name: "",
				icon: "",
				path: "",
				children: [],
			},
		};
	},
	mounted() {
        this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    },
	methods: {
		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
};
</script>
